export default __webpack_public_path__ + "static/media/roz1-small.549bef74.png";